import isEqual from 'lodash/isEqual';
import {
  Control,
  FormItem,
  FormItemHandlerTrigger,
  HandlerAction,
} from '../../../types/types';

export type PendingFullscreenHandlerMarker = {
  field: string;
  value: unknown;
  previousValue: unknown;
};

export type FireEventFn = (
  fieldName: string,
  control: Control | undefined,
  action: HandlerAction,
  formPatch?: Record<string, unknown>
) => void;

// Fires the field's handlers after a fullscreen reference confirm.
// Only fires what the field is configured for. `focusIn` never fires.
export const applyPendingFullscreenHandler = (
  marker: PendingFullscreenHandlerMarker,
  formItems: FormItem[],
  fireEvent: FireEventFn
): void => {
  const item = formItems.find((i) => i?.name === marker.field);
  const triggers: FormItemHandlerTrigger[] = item?.handlerTriggers ?? [];
  if (triggers.length === 0) return;

  const actionSet = new Set<HandlerAction>();
  triggers.forEach((t) => t.actions.forEach((a) => actionSet.add(a)));

  const formPatch = { [marker.field]: marker.value };
  const control = item?.control;

  if (actionSet.has('change')) {
    fireEvent(marker.field, control, 'change', formPatch);
  }
  // Parity with autocomplete selection (submitItems fires onChange + onTouch) — JS-1211.
  if (actionSet.has('touch')) {
    fireEvent(marker.field, control, 'touch', formPatch);
  }
  if (actionSet.has('focusOut')) {
    fireEvent(marker.field, control, 'focusOut', formPatch);
  }
  if (
    actionSet.has('focusOutChanged') &&
    !isEqual(marker.value, marker.previousValue)
  ) {
    fireEvent(marker.field, control, 'focusOutChanged', formPatch);
  }
};
